import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { observable, computed, action } from 'mobx';
import { computedFn } from 'mobx-utils';
import _get from 'lodash/get';
import { mapInitialStateToStoreState, flow } from "../../utils/store.utils/index.js";
import { ACTION_TYPES, API_STATE, CART_PRODUCT_TYPES } from "../../constants/index.js";
import { SaleClient } from "../../clients/sale.client.js";
import { isRuleLineItem, isLoyaltyLineItem, isCouponLineItem } from "../../utils/sale.utils/index.js";
import { priceBreakDownFactory, totalBreakDownFactory } from "../../factories/sale.factory.js";
import saleBreakDownFactory from "../../factories/sale-breakdown.factory.js";
import ordersBreakdownFactory from "../../factories/sale-orders-breakdown.factory.js";
import cartsBreakdownFactory from "../../factories/sale-carts-breakdown.factory.js";
import { cartContactFactory } from "../../factories/cart-contact.factory.js";
var INITIAL = API_STATE.INITIAL,
  LOADING = API_STATE.LOADING,
  SUCCESS = API_STATE.SUCCESS,
  FAILED = API_STATE.FAILED;
var FETCH_SALE = ACTION_TYPES.FETCH_SALE;
var SaleStore = (_dec = observable.shallow, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  // eslint-disable-next-line default-param-last
  function SaleStore(initialState, $env) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    if ($env === void 0) {
      $env = {};
    }
    this.$env = void 0;
    // TODO update type to Sale
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "API_STATE", _descriptor2, this);
    _initializerDefineProperty(this, "API_ERROR", _descriptor3, this);
    /**
     * is loading
     * @param {string} actionType
     * @return {boolean}
     */
    this.isLoading = computedFn(function (actionType) {
      return _this.API_STATE[actionType] === LOADING;
    }, true);
    /**
     * is isFetched
     * @param {string} actionType
     * @return {boolean}
     */
    this.isFetched = computedFn(function (actionType) {
      return _this.API_STATE[actionType] === SUCCESS;
    }, true);
    /**
     * hasError
     * @param {string} actionType
     * @return {boolean}
     */
    this.hasError = computedFn(function (actionType) {
      return _this.API_STATE[actionType] === FAILED;
    }, true);
    /**
     * get sale by saleId
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.saleId
     * @param {Function} [prop.errorHandler]
     */
    _initializerDefineProperty(this, "getSale", _descriptor4, this);
    _initializerDefineProperty(this, "getSaleByNumber", _descriptor5, this);
    this.$env = $env;
    this.updateInitialState(initialState);
  }
  var _proto = SaleStore.prototype;
  /**
   * update initial state
   * @param {Object} initialState
   */
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  };
  /**
   * sets API state to loading,
   * clears API error before fetching
   * @param {string} actionType
   */
  _proto.setAPILoading = function setAPILoading(actionType) {
    this.API_STATE[actionType] = LOADING;
    this.API_ERROR[actionType] = null;
  };
  /**
   * handle success
   * @param {Object} data
   * @param {string} actionType
   */
  _proto.onSuccess = function onSuccess(data, actionType) {
    this.API_STATE[actionType] = SUCCESS;
    this.data = data;
  }

  /**
   * handle error
   * @param {Object} error
   * @param {Function} errorHandler
   * @param {string} actionType
   */;
  _proto.onError = function onError(error, errorHandler, actionType) {
    var _error$response$data, _error$response;
    this.API_STATE[actionType] = FAILED;
    var errorResponse = (_error$response$data = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) !== null && _error$response$data !== void 0 ? _error$response$data : error.response;
    this.API_ERROR[actionType] = errorResponse;
    errorHandler(errorResponse || error);
  }

  /**
   * reset API state to default
   */;
  _proto.resetApiState = function resetApiState() {
    var _this$API_STATE, _this$API_ERROR;
    this.data = {};
    this.API_STATE = (_this$API_STATE = {}, _this$API_STATE[FETCH_SALE] = INITIAL, _this$API_STATE);
    this.API_ERROR = (_this$API_ERROR = {}, _this$API_ERROR[FETCH_SALE] = null, _this$API_ERROR);
  };
  _createClass(SaleStore, [{
    key: "id",
    get:
    /**
     * sale id
     * @return {string}
     */
    function get() {
      var _this$data;
      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.saleId;
    }

    /**
     * sale id
     * @return {string}
     */
  }, {
    key: "saleNumber",
    get: function get() {
      var _this$data2;
      return (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.saleNumber;
    }

    /**
     * sale id
     * @return {boolean}
     */
  }, {
    key: "isPostSale",
    get: function get() {
      var _this$data3;
      return !!((_this$data3 = this.data) !== null && _this$data3 !== void 0 && _this$data3.saleNumber);
    }

    /**
     * createdAt
     * @return {Date}
     */
  }, {
    key: "createdAt",
    get: function get() {
      var _this$data4;
      return (_this$data4 = this.data) === null || _this$data4 === void 0 ? void 0 : _this$data4.createdAt;
    }

    /**
     * cart track id
     * @return {string}
     */
  }, {
    key: "trackId",
    get: function get() {
      var _this$data5;
      return (_this$data5 = this.data) === null || _this$data5 === void 0 ? void 0 : _this$data5.trackId;
    }

    /**
     * contact
     * @return {Object}
     */
  }, {
    key: "contact",
    get: function get() {
      var _this$$env$config;
      return cartContactFactory(_get(this.data, 'contact'), (_this$$env$config = this.$env.config) === null || _this$$env$config === void 0 ? void 0 : _this$$env$config.dialCode);
    }

    /**
     * all cart objects
     * @return {string}
     */
  }, {
    key: "bookings",
    get: function get() {
      var _this$data6;
      return (_this$data6 = this.data) === null || _this$data6 === void 0 ? void 0 : _this$data6.bookings;
    }

    /**
     * all  carts ids
     * @return {string}
     */
  }, {
    key: "orders",
    get: function get() {
      var _this$data7;
      return (_this$data7 = this.data) === null || _this$data7 === void 0 ? void 0 : _this$data7.orders;
    }

    /**
     * all cart objects
     * @return {string}
     */
  }, {
    key: "cartsObject",
    get: function get() {
      var _this$data8;
      return (_this$data8 = this.data) === null || _this$data8 === void 0 ? void 0 : _this$data8.cartsObject;
    }

    /**
     * all  carts ids
     * @return {string}
     */
  }, {
    key: "carts",
    get: function get() {
      var _this$data9;
      return (_this$data9 = this.data) === null || _this$data9 === void 0 ? void 0 : _this$data9.carts;
    }

    /**
     * line Items of sale
     * @return {LineItem[]}
     */
  }, {
    key: "includeTotalWithVat",
    get: function get() {
      var _this$data10, _this$data10$displayI;
      return (_this$data10 = this.data) === null || _this$data10 === void 0 ? void 0 : (_this$data10$displayI = _this$data10.displayItems) === null || _this$data10$displayI === void 0 ? void 0 : _this$data10$displayI.includeTotalWithVat;
    }

    /**
     * line Items of sale
     * @return {LineItem[]}
     */
  }, {
    key: "lineItems",
    get: function get() {
      var _this$data11, _this$data11$displayI;
      return (_this$data11 = this.data) === null || _this$data11 === void 0 ? void 0 : (_this$data11$displayI = _this$data11.displayItems) === null || _this$data11$displayI === void 0 ? void 0 : _this$data11$displayI.lineItems;
    }
  }, {
    key: "payments",
    get: function get() {
      var _this$data12, _this$data12$displayI;
      return ((_this$data12 = this.data) === null || _this$data12 === void 0 ? void 0 : (_this$data12$displayI = _this$data12.displayItems) === null || _this$data12$displayI === void 0 ? void 0 : _this$data12$displayI.payments) || [];
    }
  }, {
    key: "saleDisplaytotal",
    get: function get() {
      var _this$data13, _this$data13$displayI;
      return ((_this$data13 = this.data) === null || _this$data13 === void 0 ? void 0 : (_this$data13$displayI = _this$data13.displayItems) === null || _this$data13$displayI === void 0 ? void 0 : _this$data13$displayI.total) || {};
    }

    /**
     * valid loyalty products
     * @return {Array<Object>}
     */
  }, {
    key: "validLoyalties",
    get: function get() {
      var _this$data14, _this$data14$displayI, _this$data14$displayI2;
      return (_this$data14 = this.data) === null || _this$data14 === void 0 ? void 0 : (_this$data14$displayI = _this$data14.displayItems) === null || _this$data14$displayI === void 0 ? void 0 : (_this$data14$displayI2 = _this$data14$displayI.payments) === null || _this$data14$displayI2 === void 0 ? void 0 : _this$data14$displayI2.find(isLoyaltyLineItem);
    }

    /**
     * valid rule products
     * @return {Array<Object>}
     */
  }, {
    key: "validRules",
    get: function get() {
      var _this$data15, _this$data15$displayI, _this$data15$displayI2;
      return (_this$data15 = this.data) === null || _this$data15 === void 0 ? void 0 : (_this$data15$displayI = _this$data15.displayItems) === null || _this$data15$displayI === void 0 ? void 0 : (_this$data15$displayI2 = _this$data15$displayI.lineItems) === null || _this$data15$displayI2 === void 0 ? void 0 : _this$data15$displayI2.filter(isRuleLineItem);
    }
  }, {
    key: "saleCoupon",
    get: function get() {
      var _this$data16;
      return (_this$data16 = this.data) === null || _this$data16 === void 0 ? void 0 : _this$data16.coupon;
    }
  }, {
    key: "hasCoupon",
    get: function get() {
      var _this$data17;
      return !!((_this$data17 = this.data) !== null && _this$data17 !== void 0 && _this$data17.coupon);
    }
  }, {
    key: "validCoupon",
    get: function get() {
      var _this$lineItems;
      return (_this$lineItems = this.lineItems) === null || _this$lineItems === void 0 ? void 0 : _this$lineItems.find(isCouponLineItem);
    }
  }, {
    key: "productCartType",
    get: function get() {
      var _this$carts, _this$carts$find;
      return (_this$carts = this.carts) === null || _this$carts === void 0 ? void 0 : (_this$carts$find = _this$carts.find(function (cart) {
        return cart.type === CART_PRODUCT_TYPES.HOTEL || cart.type === CART_PRODUCT_TYPES.FLIGHT || cart.type === CART_PRODUCT_TYPES.ACTIVITIES;
      })) === null || _this$carts$find === void 0 ? void 0 : _this$carts$find.type;
    }
  }, {
    key: "priceBreakDown",
    get: function get() {
      var _this$$env$currency;
      return priceBreakDownFactory({
        saleStore: this,
        formatPrice: (_this$$env$currency = this.$env.currency) === null || _this$$env$currency === void 0 ? void 0 : _this$$env$currency.formatPriceOnly
      });
    }
  }, {
    key: "productsBreakdown",
    get: function get() {
      return this.saleNumber ? ordersBreakdownFactory({
        saleStore: this
      }) : cartsBreakdownFactory({
        saleStore: this
      });
    }
  }, {
    key: "saleBreakDown",
    get: function get() {
      //
      return saleBreakDownFactory({
        saleStore: this
      });
    }

    /**
     * Total Break down
     * @return {Object}
     */
  }, {
    key: "totalBreakDown",
    get: function get() {
      var _this$data18, _this$$env$currency2;
      return totalBreakDownFactory({
        displayItems: (_this$data18 = this.data) === null || _this$data18 === void 0 ? void 0 : _this$data18.displayItems,
        formatPrice: (_this$$env$currency2 = this.$env.currency) === null || _this$$env$currency2 === void 0 ? void 0 : _this$$env$currency2.formatPriceOnly
      });
    }
  }, {
    key: "hasMultiCart",
    get: function get() {
      var _this$carts2, _this$data19, _this$data19$bookings;
      return (this === null || this === void 0 ? void 0 : (_this$carts2 = this.carts) === null || _this$carts2 === void 0 ? void 0 : _this$carts2.length) > 1 || (this === null || this === void 0 ? void 0 : (_this$data19 = this.data) === null || _this$data19 === void 0 ? void 0 : (_this$data19$bookings = _this$data19.bookings) === null || _this$data19$bookings === void 0 ? void 0 : _this$data19$bookings.length) > 1;
    }
  }, {
    key: "baseTotal",
    get: function get() {
      var _this$data20, _this$data20$saleTota;
      return (_this$data20 = this.data) === null || _this$data20 === void 0 ? void 0 : (_this$data20$saleTota = _this$data20.saleTotal) === null || _this$data20$saleTota === void 0 ? void 0 : _this$data20$saleTota.total;
    }
  }, {
    key: "baseTotalToBePaid",
    get: function get() {
      var _this$data21, _this$data21$saleTota;
      return (_this$data21 = this.data) === null || _this$data21 === void 0 ? void 0 : (_this$data21$saleTota = _this$data21.saleTotal) === null || _this$data21$saleTota === void 0 ? void 0 : _this$data21$saleTota.totalToBePaid;
    }
  }, {
    key: "baseTotalCurrency",
    get: function get() {
      var _this$data22, _this$data22$saleTota;
      return (_this$data22 = this.data) === null || _this$data22 === void 0 ? void 0 : (_this$data22$saleTota = _this$data22.saleTotal) === null || _this$data22$saleTota === void 0 ? void 0 : _this$data22$saleTota.currency;
    }
  }, {
    key: "displayedTotalToBePaid",
    get: function get() {
      var _this$$env$currency3, _this$data23, _this$data23$displayI, _this$data23$displayI2;
      return (_this$$env$currency3 = this.$env.currency) === null || _this$$env$currency3 === void 0 ? void 0 : _this$$env$currency3.formatPriceOnly(this === null || this === void 0 ? void 0 : (_this$data23 = this.data) === null || _this$data23 === void 0 ? void 0 : (_this$data23$displayI = _this$data23.displayItems) === null || _this$data23$displayI === void 0 ? void 0 : (_this$data23$displayI2 = _this$data23$displayI.total) === null || _this$data23$displayI2 === void 0 ? void 0 : _this$data23$displayI2.totalToBePaid);
    }
  }, {
    key: "displayedTotal",
    get: function get() {
      var _this$$env$currency4, _this$data24, _this$data24$displayI, _this$data24$displayI2;
      return (_this$$env$currency4 = this.$env.currency) === null || _this$$env$currency4 === void 0 ? void 0 : _this$$env$currency4.formatPriceOnly(this === null || this === void 0 ? void 0 : (_this$data24 = this.data) === null || _this$data24 === void 0 ? void 0 : (_this$data24$displayI = _this$data24.displayItems) === null || _this$data24$displayI === void 0 ? void 0 : (_this$data24$displayI2 = _this$data24$displayI.total) === null || _this$data24$displayI2 === void 0 ? void 0 : _this$data24$displayI2.total);
    }
  }]);
  return SaleStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "API_STATE", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _ref;
    return _ref = {}, _ref[FETCH_SALE] = INITIAL, _ref;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "API_ERROR", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _ref2;
    return _ref2 = {}, _ref2[FETCH_SALE] = null, _ref2;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "id", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "id"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saleNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "saleNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPostSale", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPostSale"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createdAt", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "createdAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "trackId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contact", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "contact"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bookings", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "bookings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orders", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartsObject", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartsObject"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "carts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "carts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "includeTotalWithVat", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "includeTotalWithVat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lineItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lineItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saleDisplaytotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "saleDisplaytotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validLoyalties", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validLoyalties"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validRules", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validRules"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saleCoupon", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "saleCoupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCoupon", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCoupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validCoupon", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validCoupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "productCartType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "productCartType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "priceBreakDown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "priceBreakDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "productsBreakdown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "productsBreakdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saleBreakDown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "saleBreakDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalBreakDown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalBreakDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasMultiCart", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMultiCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "baseTotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "baseTotalToBePaid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseTotalToBePaid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "baseTotalCurrency", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseTotalCurrency"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedTotalToBePaid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedTotalToBePaid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedTotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAPILoading", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAPILoading"), _class.prototype), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "getSale", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function getSale(_ref3) {
      var _this2 = this;
      var payload = _ref3.payload,
        _ref3$errorHandler = _ref3.errorHandler,
        errorHandler = _ref3$errorHandler === void 0 ? function () {
          return null;
        } : _ref3$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.setAPILoading(FETCH_SALE);
              _context.prev = 1;
              _context.next = 4;
              return SaleClient.getCart(payload);
            case 4:
              response = _context.sent;
              _this2.onSuccess(response, FETCH_SALE);
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              _this2.onError(_context.t0, errorHandler, FETCH_SALE);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "getSaleByNumber", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function getSale(_ref4) {
      var _this3 = this;
      var payload = _ref4.payload,
        _ref4$errorHandler = _ref4.errorHandler,
        errorHandler = _ref4$errorHandler === void 0 ? function () {
          return null;
        } : _ref4$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.setAPILoading(FETCH_SALE);
              _context2.prev = 1;
              _context2.next = 4;
              return SaleClient.getSaleByNumber(payload);
            case 4:
              response = _context2.sent;
              _this3.onSuccess(response, FETCH_SALE);
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              _this3.onError(_context2.t0, errorHandler, FETCH_SALE);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 8]]);
      })();
    });
  }
}), _applyDecoratedDescriptor(_class.prototype, "onSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetApiState", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "resetApiState"), _class.prototype)), _class));
export { SaleStore as default };